module.exports = __webpack_public_path__ + "static/media/paragon-fellowship-jurnalisme-pendidikan.1505330c.jpeg";